<template>
    <modal :title="'Match Agency Operators ('+setModel.AgencyName+')'" :size="'md'" @close="$emit('close')">
        <template #content>
            <loadArea v-if="countries==null"></loadArea>
            <Form method="dialog" v-slot="{ errors }" v-if="countries!=null" class="floating-labels p-1rem row" ref="form">
                <div class="col-md-12">
                    <selectBox :title="'OperatorId'" :as="'select'" :disabled="countries.length==0" v-model="model.OperatorId" :rules="{required:true}" :errors="errors" @keydown.enter="save">
                        <template #search>
                            <input type="text" placeholder="Ara" class="form-control small" v-model="searchCountrys">
                        </template>
                        <template #input>
                            <option :value="null"></option>
                            <template  v-for="item in countries">
                                <option :value="item.Id" v-if="item.Name.toUpperCase().indexOf(searchCountrys.toUpperCase())>-1" :key="item.Code">{{item.Name}}</option>
                            </template>
                        </template>
                    </selectBox>
                </div>
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :disabled="countries==null" :process="process">{{'Match Agency Operators'}}</Btn>
        </template>
    </modal>
</template>

<script>
    import selectBox from "@/components/formGroup/selectBox"
    export default {
        props:{
            setModel:Object,
            operators:Array
        },
        components:{selectBox},
        data(){
            return{
                model:{
                    Id:this.setModel.Id,
                    OperatorId:null
                },
                searchCountrys:"",
                process:false,
                countries:null
            }
        },
        watch:{
            // selectCountry(){
            //     this.model.CountryId=this.selectCountry.Id;
            //     this.model.Code1=this.selectCountry.ISO2;
            //     this.model.Code2=this.selectCountry.ISO3;
            //     this.model.Code3=this.selectCountry.CurrencyCode;
            // }
        },
        created(){
            this.$appAxiosAdmin.get(`Operators/Country/228`).then(response => {
                this.countries=response.data;
            }).catch(err=>{
                this.$isError(err);
                this.$emit('close');
            });
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.post(`KOLAYREZ/ProviderAgencyOperators/Match`,this.model).then(() => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:"Hotel name successfully matched",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            this.$emit("match",{...this.setModel,OperatorId:this.model.OperatorId,Name:this.countries.filter(x=>{return x.Id==this.model.OperatorId})[0].Name});
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$swal({
                                icon:"error",
                                title:"Error",
                                text:err.response.data.title,
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>